var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{attrs:{"size":"24","width":_vm.isDownloading ? 12 : 2,"rotate":"-90","value":_vm.value * 100,"indeterminate":!_vm.isDownloading}})}
var staticRenderFns = []

export { render, staticRenderFns }